import { Switch } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { profitStockPage, purchasePage } from "../../../API";
import Pagination from "../../../components/Pagination";
import { useNavigate } from "react-router";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();

  const [pageSize, setPageSize] = React.useState(20)
  const [totalPages, setTotalPages] = React.useState(0)
  const [productList, setProductList] = React.useState<any>([])
  const [pageIndex, setPageIndex] = React.useState(1)
  useEffect(() => {
    handlePurchasePage(pageIndex)
  }, [pageIndex])
  const handlePurchasePage = (page: number) => {
    profitStockPage({
      "pageNum": pageIndex,
      "pageSize": pageSize,
    }).then((res) => {
      setProductList(res.data.records)
      setTotalPages(res.data.total)
    }).catch((err) => {
      console.log(err)
    })
  }
  const navigate = useNavigate()

  return (
    <div className="">
      {
        productList && productList.map((item: any, index: number) => (
          <div className="mb-10 pb-10 cursor-pointer"
            key={index}
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, .2)"
            }}
            onClick={() => {
              navigate(`/product?id=${item?.productId}&category=${'精選商品'}`)
            }}
          >
            <div className="flex">
              <img src={item?.imageUrl}
                className="w-[100px] h-[100px] rounded-[10px] mr-[15px] object-cover"
                alt="" />
              <div className="flex-1">
                <div className="text-[16px] text-[#181512] font-bold  line-clamp-1">{item?.productName}</div>
                <div className="text-[14px] text-[#595959] ">進價：US$ {item?.purchaseDiscountPriceTotal}</div>
                <div className="text-[14px] text-[#595959] ">賣價：US${item?.currentPrice}</div>
                <div className="text-[14px] text-[#595959] font-bold flex items-center">
                  商品盈利：
                  <span className="text-[#ee0a24]">US$ {item?.profit}</span>
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="w-[115px] "></div>
              <div className="text-[14px] text-[#595959] ">{item?.createTime}</div>
            </div>
          </div>
        ))
      }
      <div className="flex justify-center pb-[30px] pt-20">
        {
          Math.ceil(totalPages / pageSize) > 1 ?
            <Pagination
              totalPages={Math.ceil(totalPages / pageSize)}
              currentPage={pageIndex}
              onPageChange={(page: number) => setPageIndex(page)}
            /> : ''
        }
      </div>
    </div>
  );
};

export default ComponentName;
